exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host ::ng-deep .chart-legend {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n:host ::ng-deep .chart-legend--vertical {\n  flex-direction: column;\n}\n\n:host ::ng-deep .chart-legend .chart-legend__item {\n  display: flex;\n  flex-wrap: nowrap;\n  margin-right: 10px;\n}\n\n:host ::ng-deep .chart-legend .chart-legend__item.selectable {\n  cursor: pointer;\n}\n\n:host ::ng-deep .chart-legend .chart-legend__item div.item-title {\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n\n:host ::ng-deep .chart-legend .chart-legend__item div.item-title.selected-item {\n  font-weight: bold;\n}\n\n", ""]);

// exports
